<stb-accordion [rebrand]="true">
  <stb-accordion-item [headerText]="'keycloak.info.heading' | fms">
    <p>{{ "keyloak.role.info" | fms }}</p>
    <ul>
      @for (translatedRole of translatedRoles$ | async; track translatedRole) {
        <li>
          <p>
            {{ translatedRole }}
          </p>
        </li>
      }
    </ul>
  </stb-accordion-item>
</stb-accordion>
